function getAppInfo() {
  var u = window.navigator.userAgent;
  var re = {}, mc;
  //isApp
  mc = /(kadaiApp|phApp)\/([^\s]+)/.test(u) || /com.xiaoying.wallet\/([^\s]+)/.test(u);
  re.app = mc;
  //language
  mc = u.match(/\(language\/([^\s]+)\)/);
  if (mc && mc[1]) {
    re.language = mc[1];
  }
  //mac_id
  mc = u.match(/\(macid\/([^\s]+)\)/);
  if (mc && mc[1]) {
    re.macId = mc[1];
  }
  //os
  mc = u.match(/\(os\/([^\s]+)\)/) || u.match(/(ios|android)_([^\s]+)/);
  if (mc && mc[1]) {
    re.os = mc[1];
  }
  //os_version
  mc = u.match(/\(osversion\/([^\s]+)\)/);
  if (mc && mc[1]) {
    re.osVersion = mc[1];
  }
  mc = u.match(/(ios|android)_([^\s;]+)/);
  if (mc && mc[2]) {
    re.osVersion = mc[2];
  }
  //soft_version
  mc = u.match(/\(softversion\/([^\s]+)\)/) || u.match(/com.xiaoying.wallet\/([^\s]+)/);
  if (mc && mc[1]) {
    re.softVersion = mc[1];
  }
  return re;
}

export default getAppInfo;
